import { cn } from "@base/lib/utils";
import { forwardRef } from "react";
import type { ProgressBarProps, ProgressBarSize } from "./types";

const sizeStyles: Record<ProgressBarSize, string> = {
  light: "h-1",
  normal: "h-2",
  bold: "h-3",
};

const ProgressBar = forwardRef<HTMLDivElement, ProgressBarProps>(
  ({ progress, size = "normal", color = "#5A7EE9", withAnimation = false, className, ...props }, ref) => {
    const clampedProgress = Math.min(100, Math.max(0, progress));

    return (
      // biome-ignore lint/a11y/useFocusableInteractive: <explanation>
      <div
        ref={ref}
        role="progressbar"
        aria-valuenow={clampedProgress}
        aria-valuemin={0}
        aria-valuemax={100}
        className={cn("overflow-hidden w-full", sizeStyles[size], className)}
        {...props}
      >
        <div
          className={cn("h-full", withAnimation && "transition-all duration-300 ease-out")}
          style={{
            width: `${clampedProgress}%`,
            ...(color && { backgroundColor: color }),
          }}
        />
      </div>
    );
  },
);

ProgressBar.displayName = "ProgressBar";

export { ProgressBar };
export type { ProgressBarProps, ProgressBarSize };
